module.exports = __webpack_public_path__ + "img/91.6.CODm.152d787d.png";